var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "44px",
    viewBox: "0 0 47 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_youtube") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BDF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003FD1",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3333343,6 C29.9466687,6 35.7066687,6.64 39.3333343,7.17333433 C41.5733343,7.49333433 43.3866687,9.2 43.8133343,11.44 C44.24,13.8933343 44.7733343,17.52 44.7733343,22 C44.6666687,26.48 44.24,30.1066657 43.8133343,32.56 C43.3866687,34.8 41.5733343,36.5066657 39.3333343,36.8266657 C35.8133343,37.36 29.9466687,38 23.3333343,38 C16.8266687,38 10.96,37.36 7.33333433,36.8266657 C5.09333433,36.5066657 3.28,34.8 2.85333433,32.56 C2.42666865,30.1066657 2,26.48 2,22 C2,17.52 2.42666567,13.8933343 2.85333433,11.44 C3.28,9.2 5.09333433,7.49333433 7.33333433,7.17333433 C10.8533343,6.64 16.72,6 23.3333343,6 Z M19.0666687,14.5333313 L19.0666687,29.4666657 L31.8666687,21.999997 L19.0666687,14.5333313 Z",
    id: "ic_youtube",
    fill: "url(#linearGradient-1)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYoutube);
export default __webpack_public_path__ + "static/media/ic_youtube.dfac8e75cf0bb68f47189cf5dc67a8cd.svg";
export { ForwardRef as ReactComponent };